const   Datepicker = require('air-datepicker'),
        lang = $("html").attr("lang");

if(lang !== "ru") {
    $.fn.datepicker.language['en'] = {
        days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        daysShort: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
        daysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        today: 'Today',
        clear: 'Clear'
    };
}

const $formDate = $('.js-form-date');

class DatepickerForm {
    constructor(container) {
        this.container = container;
        this.containerFilterDatepicker = this.container.find('.js-form__datepicker');
    }

    initDatepicker() {
        this.containerFilterDatepicker
            .datepicker({
                language: 'en',
                autoClose: true,
                onSelect: function (formattedDate, date, inst) {
                    $(inst.el).trigger('change');
                }
            });
    }

    create() {
        this.initDatepicker();

// белиберда для цвета датапикера ===>
        $('.js-form__datepicker').on('change', function () {
            let $this = $(this);
            let thisLabel = $this.closest('label');

            if ($this.val() == '') {
                thisLabel.addClass('empty');
            } else {
                thisLabel.removeClass('empty');
            }
        });
// <===

    }
};

$(".js-flight-enquiry-checkbox").on('click', function (e) {
    const   $obj = $(this),
            data = $obj.data("active");

    if(data) {
        $formDate.show();
        $obj.data("active", 0);
    } else {
        $formDate.hide();
        $obj.data("active", 1)
    }
});

let datepicker = new DatepickerForm($formDate);
datepicker.create();


// WEBPACK FOOTER //
// ./frontend/components/flight-enquiry/flight-enquiry.js